<div
  class="upload-zone"
  [class.upload-zone--disabled]="disabled()"
  (drop)="onDrop($event)"
  (dragover)="onDragOver($event)"
>
  <p class="upload-zone__label">{{ label() }}</p>
  <p class="upload-zone__hint">{{ hint() }}</p>
  <label class="upload-zone__button">
    <input
      type="file"
      [accept]="accept()"
      [multiple]="multiple()"
      [disabled]="disabled()"
      (change)="onChange($event)"
    />
    Choose files
  </label>
</div>
